import React from 'react';
import { MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card } from './ui/card';
import { images } from '../data/mockData';

const VrindavanAttractions = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="h-px w-12 bg-orange-400" />
              <div className="w-2 h-2 rotate-45 bg-orange-400" />
              <div className="h-px w-12 bg-orange-400" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              {language === 'bn' ? 'বৃন্দাবনের আকর্ষণ' : 'Explore Vrindavan'}
            </h2>
            <p className="text-lg text-gray-600">
              {language === 'bn' 
                ? 'বিখ্যাত মন্দির এবং উৎসব আবিষ্কার করুন' 
                : 'Discover famous temples and festivals'}
            </p>
          </div>

          {/* Attractions Grid */}
          <div className="grid md:grid-cols-3 gap-6">
            {images.vrindavanAttractions.map((attraction, index) => (
              <Card 
                key={index}
                className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden group bg-white"
              >
                <div className="relative h-64">
                  <img
                    src={attraction.url}
                    alt={attraction.name[language]}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                  
                  {/* Content Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="flex items-start space-x-3">
                      <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0 shadow-lg">
                        <MapPin className="w-5 h-5 text-white" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-white mb-1">
                          {attraction.name[language]}
                        </h3>
                        <p className="text-orange-200 text-sm">
                          {attraction.description[language]}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Info Banner */}
          <div className="mt-12 bg-gradient-to-r from-orange-50 to-red-50 border-2 border-orange-200 rounded-xl p-8 text-center">
            <h3 className="text-2xl font-bold text-gray-800 mb-3">
              {language === 'bn' 
                ? 'সমস্ত মন্দির আমাদের হোমস্টে থেকে হাঁটার দূরত্বে' 
                : 'All temples within walking distance from our homestay'}
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              {language === 'bn'
                ? 'আপনার আধ্যাত্মিক যাত্রার জন্য আদর্শ অবস্থান। হোলি, জন্মাষ্টমী এবং অন্যান্য উৎসবের সময় বিশেষ ব্যবস্থা উপলব্ধ।'
                : 'Perfect location for your spiritual journey. Special arrangements available during Holi, Janmashtami and other festivals.'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VrindavanAttractions;
